import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.180 4.577 C 12.823 4.736,12.664 5.170,12.822 5.551 C 12.865 5.655,13.721 6.538,15.651 8.469 L 18.418 11.239 10.979 11.249 C 3.622 11.260,3.539 11.261,3.404 11.340 C 3.330 11.384,3.213 11.489,3.144 11.574 C 3.032 11.712,3.020 11.755,3.020 12.000 C 3.020 12.244,3.033 12.289,3.142 12.426 C 3.210 12.511,3.344 12.621,3.441 12.670 L 3.617 12.760 11.018 12.760 L 18.419 12.760 15.651 15.530 C 13.721 17.462,12.865 18.345,12.822 18.449 C 12.746 18.632,12.742 18.881,12.814 19.052 C 12.890 19.234,13.133 19.435,13.311 19.463 C 13.393 19.476,13.469 19.488,13.480 19.490 C 13.491 19.492,13.581 19.481,13.680 19.465 C 13.855 19.438,13.962 19.335,17.374 15.928 C 19.421 13.885,20.911 12.366,20.944 12.291 C 21.016 12.127,21.016 11.873,20.944 11.709 C 20.871 11.541,13.938 4.618,13.787 4.562 C 13.633 4.504,13.325 4.512,13.180 4.577 ",
		stroke: "none",
		fillRule: "evenodd",
		fill: "currentColor"
	})
});
export default SvgArrowRight;
